import { Component } from '@angular/core';
import { inject } from '@angular/core';
import { OrderProcessingService } from 'app/server/server.module';
import { OrderlinePanelComponent } from 'app/shared/orderline-panel/orderline-panel.component';
import { takeUntil } from 'rxjs';

@Component({
  selector: 'app-proformas-and-quotes',
  templateUrl: '../../shared/orderline-panel/orderline-panel.component.html',
  styleUrls: ['../../shared/orderline-panel/orderline-panel.component.scss']
})
export class ProformasAndQuotesComponent extends OrderlinePanelComponent {
  private readonly orderService = inject(OrderProcessingService);

  constructor() {
    super();
    this.title = "Proformas and Quotes";
  }

  refreshData(): void {
    if (this.selectedAdmin !== null) {
      this.orderService.getProFormasAndQuotes(this.selectedAdmin).pipe(takeUntil(this.destroy$)).subscribe(res => this.datasource = res || []);
    }
  }
}
